(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var _ieDetect = require("./scripts/ieDetect");

var _siema = _interopRequireDefault(require("./plugins/slider/siema.dev"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ieVersion = _ieDetect.IE;

if (parseInt(ieVersion.actualVersion) < 10) {
  var element = document.createElement('div');
  element.classList.add('ie-notice');
  element.innerHTML = "\n    <h1>Your browser is outdated.</h1>\n    <p>To enjoy a better web experience, please download a newer browser: <a href=\"https://bestvpn.org/outdatedbrowser/en\">Download</a></p>\n  ";
  document.body.insertAdjacentElement('afterbegin', element);
} else {
  var Scripts = function () {
    var PublicAPI = {};

    PublicAPI.init = function () {
      var siteSearch = document.body.querySelector('#site-search');
      var navBar = document.body.querySelector('#main-nav');
      var closeButton = navBar.querySelector('.close');
      var searchElements = document.body.querySelectorAll('.is-search-input');
      var filter = document.body.querySelector('.filter--desktop'); //var navBarOffset = navBar.offsetTop;

      /*window.addEventListener('scroll', function(){
        if(window.scrollY >= navBarOffset){
          navBar.classList.remove('bg-transparent');
          navBar.classList.add('bg-white');
        }
         if(window.scrollY === 0){
          navBar.classList.remove('bg-white');
          navBar.classList.add('bg-transparent');
        }
      });*/

      closeButton.addEventListener('click', function (e) {
        e.preventDefault();
        e.target.closest('.show').classList.remove('show');
      });

      if (document.body.querySelector('.slider')) {
        startSlider();
      }

      if (document.body.classList.contains('single-product')) {
        cloneTechnicalInformation();

        if (document.body.querySelector('.product-slider')) {
          startProductSlider();
        }
      }
      /**
       * Removes results from the end of [body]
       * and attaches them to the proper search element
       */


      if (searchElements) {
        var timer = null;
        var time = 250;
        Array.prototype.forEach.call(searchElements, function (element) {
          element.addEventListener('keyup', function (e) {
            var curtarget = e.target.closest('.search');
            var curId = e.target.id.trim();
            var cleanId = curId.replace(/\D/g, "");
            clearTimeout(timer);
            setTimeout(moveResults, time, curtarget, cleanId);
          });
        });
      }

      if (filter) {
        var mobileFilter = document.body.querySelector('#mobile-filter');
        var showFilter = document.body.querySelector('#show-filter');
        var previous = null;
        /*
        window.filters = [];
        if(window.filters.length > 0){
          Array.prototype.forEach.call(window.filters, function(item){
            var target = document.body.querySelector('#' + item);
            var selectWrap = target.querySelector('.bapf_body');
            if(!selectWrap.classList.contains('selected')){
              selectWrap.classList.add('selected');
            }
          });
        }*/

        mobileFilter.addEventListener('click', function (e) {
          if (e.target.id === 'close-filter') {
            e.preventDefault();
            mobileFilter.classList.remove('active');
          }

          if (e.target.classList.contains('bapf_head')) {
            var parent = e.target.closest('.bapf_sfilter');

            if (previous && previous !== target) {
              parent.classList.toggle('active');
              previous = parent;
            }

            parent.classList.toggle('active');
          }

          if (e.target.classList.contains('bapf_update')) {
            mobileFilter.classList.remove('active');
          }
        });
        showFilter.addEventListener('click', function (e) {
          e.preventDefault();
          mobileFilter.classList.add('active');
        });
        filter.addEventListener('click', function (e) {
          if (!e.target.classList.contains('filter__button')) {
            var curSelect = e.target;
            var curParent = curSelect.closest('.bapf_body'); //var curAncestor = curSelect.closest('.bapf_slct').id.trim();

            /*if(window.filters.indexOf(curAncestor) === -1){
              window.filters.push(curAncestor);
            }*/

            if (!curParent.classList.contains('selected')) {
              document.querySelectorAll('.filter .bapf_sfilter.bapf_slct .bapf_body').forEach(function (el) {
                el.classList.remove('selected');
              });
              curParent.classList.add('selected');
            }
          }
        });
      } //Closes the global site search


      document.addEventListener('click', function (e) {
        if (e.target.classList.contains('search__content')) {
          siteSearch.classList.remove('active');
        }
      }, false);
      document.addEventListener('keyup', function (e) {
        if (e.key === 'Escape') {
          siteSearch.classList.remove('active');
        }
      });
      startSiteSearch(siteSearch);
      var faqYes = document.body.querySelectorAll('.faq .card-body__link--yes');
      Array.prototype.forEach.call(faqYes, function (element) {
        element.addEventListener('click', function (e) {
          e.preventDefault();
          e.target.closest('.card-body__links').innerHTML = 'Tack för din feedback';
        });
      });
    };

    var moveResults = function moveResults(target, id) {
      var check = setInterval(function () {
        if (document.body.querySelector('#is-ajax-search-result-' + id)) {
          var result = document.body.querySelector('#is-ajax-search-result-' + id);
          target.appendChild(result);
          jQuery('body').on('click', '#site-search .is-ajax-search-result .is-ajax-search-items a', function (e) {
            console.log('clc');
            console.log(jQuery(e.target).attr("href"));
            window.location = jQuery(e.target).attr("href");
          });
          clearInterval(check);
        }
      }, 250);
    };

    var getProducts = function getProducts(args, target) {
      var category = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var entries = Object.values(args);
      var postOBJ = {
        category: category
      };
      Array.prototype.forEach.call(entries, function (entry) {
        if (Array.isArray(entry)) {
          var curTaxonomyName = entry[0].attr.replace('product-', 'pa_');
          postOBJ[curTaxonomyName] = [];

          for (var i = 0; i < entry[0].terms.length; i += 1) {
            postOBJ[curTaxonomyName].push(entry[0].terms[i]);
          }
        } else {
          postOBJ[entry.attr.replace('product-', 'pa_')] = entry.term;
        }
      });
      wp.ajax.post('filter_shop_products', postOBJ).done(function (res) {
        updateView(res, target);
      }).fail(function (res) {
        updateView([], target);
      });
    };

    var updateView = function updateView(products, target) {
      var content = '';

      if (products.length > 2) {
        window.products = paginateResults(products, 1, 2);
        console.log(window.products);
      }

      if (products.length < 1) {
        content += "<li class='col-12'><h3 class='text-center my-7'>Nothing to show...</h3></li>";
      } else {
        Array.prototype.forEach.call(products, function (product) {
          var image = product.image[0].replace('.png', '');
          var sku = product.data.sku;
          var render_sku = sku !== '' ? 'E-nr:' + sku : '';
          content += "\n          <li class=\"col-6 col-md-4 mb-3 mb-md-0 product-".concat(product.data.id, "\">\n            <a href=\"").concat(product.link, "\" class=\"woocommerce-LoopProduct-link woocommerce-loop-product__link\">\n              <img width=\"320\" height=\"320\" \n              src=\"").concat(image, "-320x320.png\" \n              class=\"attachment-woocommerce_thumbnail size-woocommerce_thumbnail\" alt=\"\" loading=\"lazy\" \n              srcset=\"").concat(image, "-320x320.png 320w, \n              ").concat(image, "-150x150.png 150w, \n              ").concat(image, "-173x173.png 173w, \n              ").concat(image, "-340x340.png 340w, \n              ").concat(image, "-658x658.png 658w, \n              ").concat(image, "-100x100.png 100w\" \n              sizes=\"(max-width: 320px) 100vw, 320px\">\n              <h2 class=\"woocommerce-loop-product__title\">").concat(product.data.name, "</h2><small class=\"woocommerce-loop-product__sku\">").concat(render_sku, "</small>\n            </a>\n          </li>\n          ");
        });
      }

      target.innerHTML = content;
      endLoader();
    };

    var paginateResults = function paginateResults(items, current_page, per_page_items) {
      var page = current_page || 1,
          per_page = per_page_items || 10,
          offset = (page - 1) * per_page,
          paginatedItems = items.slice(offset).slice(0, per_page_items),
          total_pages = Math.ceil(items.length / per_page);
      return {
        page: page,
        per_page: per_page,
        pre_page: page - 1 ? page - 1 : null,
        next_page: total_pages > page ? page + 1 : null,
        total: items.length,
        total_pages: total_pages,
        data: paginatedItems
      };
    };

    var startLoader = function startLoader() {
      var loader = document.createElement('div');
      loader.classList.add('loader--wrap');
      loader.id = 'loader';
      loader.innerHTML = '<div class="loader">Loading</div>';
      document.body.insertAdjacentElement('beforeend', loader);
    };

    var endLoader = function endLoader() {
      var loader = document.body.querySelector('#loader');
      loader.parentNode.removeChild(loader);
    };

    var startSlider = function startSlider() {
      var opts = {
        duration: 700,
        easing: 'ease-in-out',
        bullets: false,
        draggable: false,
        multipleDrag: false,
        loop: true,
        rtl: false,
        onInit: function onInit() {},
        onChange: function onChange() {}
      };
      opts.selector = '.slider';
      var slider = new _siema.default(opts);
      var target = document.querySelector(opts.selector);
      target.parentNode.querySelector('.prev').addEventListener('click', function () {
        return slider.prev();
      });
      target.parentNode.querySelector('.next').addEventListener('click', function () {
        return slider.next();
      });
    };

    var startProductSlider = function startProductSlider() {
      var opts = {
        duration: 500,
        easing: 'ease-in-out',
        bullets: true,
        draggable: false,
        multipleDrag: false,
        loop: true,
        rtl: false,
        onInit: function onInit() {},
        onChange: function onChange() {}
      };
      opts.selector = '.product-slider';
      var slider = new _siema.default(opts);
      var target = document.querySelector(opts.selector);
      target.parentNode.querySelector('.prev').addEventListener('click', function () {
        return slider.prev();
      });
      target.parentNode.querySelector('.next').addEventListener('click', function () {
        return slider.next();
      });
    };

    var cloneTechnicalInformation = function cloneTechnicalInformation() {
      var parent = document.body.querySelector('.container-tabs');
      var tabContent = parent.querySelector('#tab-tech_info_tab').innerHTML;
      var target = parent.querySelector('#panel-tech_info_tab .card-body');
      target.innerHTML = tabContent;
    };

    var startSiteSearch = function startSiteSearch(target) {
      target.addEventListener('click', function (e) {
        // Check if the clicked element is the search open button
        if (e.target.classList.contains('site-search')) {
          e.preventDefault(); // Prevent default only if it's the open button

          target.classList.add('active');
          console.log('Search opened');
        } else if (e.target.type === 'submit') {
          // If it's the submit button, allow the form to submit
          console.log('Submitting search');
        }
      });
    }; // Assuming 'site-search' is the class for the button to open the search form


    var searchButton = document.querySelector('.site-search');

    if (searchButton) {
      startSiteSearch(searchButton);
    }

    return PublicAPI;
  }();

  document.addEventListener('DOMContentLoaded', function () {
    console.log('done');
    Scripts.init();
    jQuery('.woocommerce-product-gallery__image > a').fancybox();
    var housingSliderStatus = jQuery('.housing-slider-status');
    var housingSlider = jQuery(".housing-slider");
    housingSlider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
      // no dots -> no slides
      if (!slick.$dots) {
        return;
      } //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)


      var i = (currentSlide ? currentSlide : 0) + 1; // use dots to get some count information

      housingSliderStatus.text(i + ' / ' + slick.$dots[0].children.length);
    });
    housingSlider.slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true
    });
    /*jQuery(".housing-other-projects-slider").slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      variableWidth: true,
      dots: false,
      arrows: false,
      focusOnSelect: false,
      touchThreshold: 1000,
      rows: 1,
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: false,
          }
        },        
      ]
    });
    jQuery('.housing-other-projects-slider').on('swipe', function(event, slick, direction){
      console.log('swipe was hit')
    });*/

    jQuery(".housing-other-projects-slider").flickity({
      // options
      cellAlign: 'left',
      contain: true,
      freeScroll: true,
      prevNextButtons: false,
      pageDots: false,
      wrapAround: true
    });

    if (jQuery(".twae-timeline-centered").length > 0) {
      jQuery(".twae-timeline-centered > .twae-timeline-entry:eq(0)").addClass('open');
      jQuery(".twae-timeline-centered > .twae-timeline-entry:eq(0) .twae-data-container").slideDown();
      jQuery(".twae-timeline-centered > .twae-timeline-entry").on('click', function () {
        jQuery(this).siblings().removeClass('open');
        jQuery(this).addClass('open');
        jQuery(this).siblings().find(".twae-data-container").slideUp();
        jQuery(this).find(".twae-data-container").slideDown();
      });
    }
    /*if (jQuery(".filter .bapf_sfilter[data-taxonomy='product_cat'] .bapf_select2").length > 0) {
      jQuery(".filter .bapf_sfilter[data-taxonomy='product_cat'] .bapf_select2 option[data-name='Uncategorised']").remove();
    }*/

  });
}

},{"./plugins/slider/siema.dev":2,"./scripts/ieDetect":3}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Siema = /*#__PURE__*/function () {
  /**
   * Create a Siema.
   * @param {Object} options - Optional settings object.
   */
  function Siema(options) {
    var _this = this;

    _classCallCheck(this, Siema);

    // Merge defaults with user's settings
    this.config = Siema.mergeSettings(options); // Resolve selector's type

    this.selector = typeof this.config.selector === 'string' ? document.querySelector(this.config.selector) : this.config.selector; // Early throw if selector doesn't exists

    if (this.selector === null) {
      throw new Error('Something wrong with your selector');
    } // update perPage number dependable of user value


    this.resolveSlidesNumber(); // Create global references

    this.selectorWidth = this.selector.offsetWidth;
    this.innerElements = [].slice.call(this.selector.children);
    this.currentSlide = this.config.loop ? this.config.startIndex % this.innerElements.length : Math.max(0, Math.min(this.config.startIndex, this.innerElements.length - this.perPage));
    this.transformProperty = Siema.webkitOrNot(); // Bind all event handlers for referencability

    ['resizeHandler', 'touchstartHandler', 'touchendHandler', 'touchmoveHandler', 'mousedownHandler', 'mouseupHandler', 'mouseleaveHandler', 'mousemoveHandler', 'mouseHoverHandler', 'clickHandler'].forEach(function (method) {
      _this[method] = _this[method].bind(_this);
    }); // Build markup and apply required styling to elements

    this.init();
  }
  /**
   * Overrides default settings with custom ones.
   * @param {Object} options - Optional settings object.
   * @returns {Object} - Custom Siema settings.
   */


  _createClass(Siema, [{
    key: "attachEvents",
    value:
    /**
     * Attaches listeners to required events.
     */
    function attachEvents() {
      // Resize element on window resize
      window.addEventListener('resize', this.resizeHandler); // If element is draggable / swipable, add event handlers

      if (this.config.draggable) {
        // Keep track pointer hold and dragging distance
        this.pointerDown = false;
        this.drag = {
          startX: 0,
          endX: 0,
          startY: 0,
          letItGo: null,
          preventClick: false
        }; // Touch events

        this.selector.addEventListener('touchstart', this.touchstartHandler);
        this.selector.addEventListener('touchend', this.touchendHandler);
        this.selector.addEventListener('touchmove', this.touchmoveHandler); // Mouse events

        this.selector.addEventListener('mousedown', this.mousedownHandler);
        this.selector.addEventListener('mouseup', this.mouseupHandler);
        this.selector.addEventListener('mouseleave', this.mouseleaveHandler);
        this.selector.addEventListener('mousemove', this.mousemoveHandler); // Click

        this.selector.addEventListener('click', this.clickHandler);
      }
    }
    /**
     * Detaches listeners from required events.
     */

  }, {
    key: "detachEvents",
    value: function detachEvents() {
      window.removeEventListener('resize', this.resizeHandler);
      this.selector.removeEventListener('touchstart', this.touchstartHandler);
      this.selector.removeEventListener('touchend', this.touchendHandler);
      this.selector.removeEventListener('touchmove', this.touchmoveHandler);
      this.selector.removeEventListener('mousedown', this.mousedownHandler);
      this.selector.removeEventListener('mouseup', this.mouseupHandler);
      this.selector.removeEventListener('mouseleave', this.mouseleaveHandler);
      this.selector.removeEventListener('mousemove', this.mousemoveHandler);
      this.selector.removeEventListener('mouseover', this.mouseHoverHandler);
      this.selector.removeEventListener('click', this.clickHandler);
    }
    /**
     * Builds the markup and attaches listeners to required events.
     */

  }, {
    key: "init",
    value: function init() {
      this.attachEvents(); // hide everything out of selector's boundaries

      this.selector.style.overflow = 'hidden'; // rtl or ltr

      this.selector.style.direction = this.config.rtl ? 'rtl' : 'ltr'; // build a frame and slide to a currentSlide

      this.buildSliderFrame(); //Slide automatically if enabled

      if (this.config.autoplay) {
        this.autoplay();
      }

      this.config.onInit.call(this);
    }
    /**
     * Build a sliderFrame and slide to a current item.
     */

  }, {
    key: "buildSliderFrame",
    value: function buildSliderFrame() {
      var widthItem = this.selectorWidth / this.perPage;
      var itemsToBuild = this.config.loop ? this.innerElements.length + 2 * this.perPage : this.innerElements.length; // Create frame and apply styling

      this.sliderFrame = document.createElement('div');
      this.sliderFrame.classList.add('slider-frame');
      this.sliderFrame.style.width = "".concat(widthItem * itemsToBuild, "px");
      this.enableTransition();

      if (this.config.draggable) {
        this.selector.style.cursor = '-webkit-grab';
      } // Create a document fragment to put slides into it


      var docFragment = document.createDocumentFragment(); // Loop through the slides, add styling and add them to document fragment

      if (this.config.loop) {
        for (var i = this.innerElements.length - this.perPage; i < this.innerElements.length; i++) {
          var element = this.buildSliderFrameItem(this.innerElements[i].cloneNode(true));
          docFragment.appendChild(element);
        }
      }

      for (var _i = 0; _i < this.innerElements.length; _i++) {
        var _element = this.buildSliderFrameItem(this.innerElements[_i]);

        docFragment.appendChild(_element);
      }

      if (this.config.loop) {
        for (var _i2 = 0; _i2 < this.perPage; _i2++) {
          var _element2 = this.buildSliderFrameItem(this.innerElements[_i2].cloneNode(true));

          docFragment.appendChild(_element2);
        }
      } // Add fragment to the frame


      this.sliderFrame.appendChild(docFragment); // Clear selector (just in case something is there) and insert a frame

      this.selector.innerHTML = '';
      this.selector.appendChild(this.sliderFrame);
      this.selector.querySelector('.slider-frame').addEventListener('mouseover', this.mouseHoverHandler); // Go to currently active slide after initial build

      this.slideToCurrent();
    }
  }, {
    key: "buildSliderFrameItem",
    value: function buildSliderFrameItem(elm) {
      var elementContainer = document.createElement('div');
      elementContainer.classList.add('slider-item');
      elementContainer.style.cssFloat = this.config.rtl ? 'right' : 'left';
      elementContainer.style.float = this.config.rtl ? 'right' : 'left';
      elementContainer.style.width = "".concat(this.config.loop ? 100 / (this.innerElements.length + this.perPage * 2) : 100 / this.innerElements.length, "%");
      elementContainer.appendChild(elm);
      return elementContainer;
    }
    /**
     * Determinates slides number accordingly to clients viewport.
     */

  }, {
    key: "resolveSlidesNumber",
    value: function resolveSlidesNumber() {
      if (typeof this.config.perPage === 'number') {
        this.perPage = this.config.perPage;
      } else if (_typeof(this.config.perPage) === 'object') {
        this.perPage = 1;

        for (var viewport in this.config.perPage) {
          if (window.innerWidth >= viewport) {
            this.perPage = this.config.perPage[viewport];
          }
        }
      }
    }
    /**
     * Go to previous slide.
     * @param {number} [howManySlides=1] - How many items to slide backward.
     * @param {function} callback - Optional callback function.
     */

  }, {
    key: "prev",
    value: function prev() {
      var howManySlides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var callback = arguments.length > 1 ? arguments[1] : undefined;

      // early return when there is nothing to slide
      if (this.innerElements.length <= this.perPage) {
        return;
      }

      var beforeChange = this.currentSlide;

      if (this.config.loop) {
        var isNewIndexClone = this.currentSlide - howManySlides < 0;

        if (isNewIndexClone) {
          this.disableTransition();
          var mirrorSlideIndex = this.currentSlide + this.innerElements.length;
          var mirrorSlideIndexOffset = this.perPage;
          var moveTo = mirrorSlideIndex + mirrorSlideIndexOffset;
          var offset = (this.config.rtl ? 1 : -1) * moveTo * (this.selectorWidth / this.perPage);
          var dragDistance = this.config.draggable ? this.drag.endX - this.drag.startX : 0;
          this.sliderFrame.style[this.transformProperty] = "translate3d(".concat(offset + dragDistance, "px, 0, 0)");
          this.currentSlide = mirrorSlideIndex - howManySlides;
        } else {
          this.currentSlide = this.currentSlide - howManySlides;
        }
      } else {
        this.currentSlide = Math.max(this.currentSlide - howManySlides, 0);
      }

      if (beforeChange !== this.currentSlide) {
        this.slideToCurrent(this.config.loop);
        this.config.onChange.call(this);

        if (callback) {
          callback.call(this);
        }
      }
    }
    /**
     * Go to next slide.
     * @param {number} [howManySlides=1] - How many items to slide forward.
     * @param {function} callback - Optional callback function.
     */

  }, {
    key: "next",
    value: function next() {
      var howManySlides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var callback = arguments.length > 1 ? arguments[1] : undefined;

      // early return when there is nothing to slide
      if (this.innerElements.length <= this.perPage) {
        return;
      }

      var beforeChange = this.currentSlide;

      if (this.config.loop) {
        var isNewIndexClone = this.currentSlide + howManySlides > this.innerElements.length - this.perPage;

        if (isNewIndexClone) {
          this.disableTransition();
          var mirrorSlideIndex = this.currentSlide - this.innerElements.length;
          var mirrorSlideIndexOffset = this.perPage;
          var moveTo = mirrorSlideIndex + mirrorSlideIndexOffset;
          var offset = (this.config.rtl ? 1 : -1) * moveTo * (this.selectorWidth / this.perPage);
          var dragDistance = this.config.draggable ? this.drag.endX - this.drag.startX : 0;
          this.sliderFrame.style[this.transformProperty] = "translate3d(".concat(offset + dragDistance, "px, 0, 0)");
          this.currentSlide = mirrorSlideIndex + howManySlides;
        } else {
          this.currentSlide = this.currentSlide + howManySlides;
        }
      } else {
        this.currentSlide = Math.min(this.currentSlide + howManySlides, this.innerElements.length - this.perPage);
      }

      if (beforeChange !== this.currentSlide) {
        this.slideToCurrent(this.config.loop);
        this.config.onChange.call(this);

        if (callback) {
          callback.call(this);
        }
      }
    }
    /**
     * Disable transition on sliderFrame.
     */

  }, {
    key: "disableTransition",
    value: function disableTransition() {
      this.sliderFrame.style.webkitTransition = "all 0ms ".concat(this.config.easing);
      this.sliderFrame.style.transition = "all 0ms ".concat(this.config.easing);
    }
    /**
     * Enable transition on sliderFrame.
     */

  }, {
    key: "enableTransition",
    value: function enableTransition() {
      this.sliderFrame.style.webkitTransition = "all ".concat(this.config.duration, "ms ").concat(this.config.easing);
      this.sliderFrame.style.transition = "all ".concat(this.config.duration, "ms ").concat(this.config.easing);
    }
    /**
     * Go to slide with particular index
     * @param {number} index - Item index to slide to.
     * @param {function} callback - Optional callback function.
     */

  }, {
    key: "goTo",
    value: function goTo(index, callback) {
      if (this.innerElements.length <= this.perPage) {
        return;
      }

      var beforeChange = this.currentSlide;
      this.currentSlide = this.config.loop ? index % this.innerElements.length : Math.min(Math.max(index, 0), this.innerElements.length - this.perPage);

      if (beforeChange !== this.currentSlide) {
        this.slideToCurrent();
        this.config.onChange.call(this);

        if (callback) {
          callback.call(this);
        }
      }
    }
    /**
     * Moves sliders frame to position of currently active slide
     */

  }, {
    key: "slideToCurrent",
    value: function slideToCurrent(enableTransition) {
      var _this2 = this;

      var currentSlide = this.config.loop ? this.currentSlide + this.perPage : this.currentSlide;
      var offset = (this.config.rtl ? 1 : -1) * currentSlide * (this.selectorWidth / this.perPage);

      if (enableTransition) {
        // This one is tricky, I know but this is a perfect explanation:
        // https://youtu.be/cCOL7MC4Pl0
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            _this2.enableTransition();

            _this2.sliderFrame.style[_this2.transformProperty] = "translate3d(".concat(offset, "px, 0, 0)");
          });
        });
      } else {
        this.sliderFrame.style[this.transformProperty] = "translate3d(".concat(offset, "px, 0, 0)");
      }
    }
    /**
     * Recalculate drag /swipe event and reposition the frame of a slider
     */

  }, {
    key: "updateAfterDrag",
    value: function updateAfterDrag() {
      var movement = (this.config.rtl ? -1 : 1) * (this.drag.endX - this.drag.startX);
      var movementDistance = Math.abs(movement);
      var howManySliderToSlide = this.config.multipleDrag ? Math.ceil(movementDistance / (this.selectorWidth / this.perPage)) : 1;
      var slideToNegativeClone = movement > 0 && this.currentSlide - howManySliderToSlide < 0;
      var slideToPositiveClone = movement < 0 && this.currentSlide + howManySliderToSlide > this.innerElements.length - this.perPage;

      if (movement > 0 && movementDistance > this.config.threshold && this.innerElements.length > this.perPage) {
        this.prev(howManySliderToSlide);
      } else if (movement < 0 && movementDistance > this.config.threshold && this.innerElements.length > this.perPage) {
        this.next(howManySliderToSlide);
      }

      this.slideToCurrent(slideToNegativeClone || slideToPositiveClone);
    }
    /**
     * When window resizes, resize slider components as well
     */

  }, {
    key: "resizeHandler",
    value: function resizeHandler() {
      // update perPage number dependable of user value
      this.resolveSlidesNumber(); // relcalculate currentSlide
      // prevent hiding items when browser width increases

      if (this.currentSlide + this.perPage > this.innerElements.length) {
        this.currentSlide = this.innerElements.length <= this.perPage ? 0 : this.innerElements.length - this.perPage;
      }

      this.selectorWidth = this.selector.offsetWidth;
      this.buildSliderFrame();
    }
    /**
     * Clear drag after touchend and mouseup event
     */

  }, {
    key: "clearDrag",
    value: function clearDrag() {
      this.drag = {
        startX: 0,
        endX: 0,
        startY: 0,
        letItGo: null,
        preventClick: this.drag.preventClick
      };
    }
    /**
     * touchstart event handler
     */

  }, {
    key: "touchstartHandler",
    value: function touchstartHandler(e) {
      // Prevent dragging / swiping on inputs, selects and textareas
      var ignoreSiema = ['TEXTAREA', 'OPTION', 'INPUT', 'SELECT'].indexOf(e.target.nodeName) !== -1;

      if (ignoreSiema) {
        return;
      }

      e.stopPropagation();
      this.pointerDown = true;
      this.drag.startX = e.touches[0].pageX;
      this.drag.startY = e.touches[0].pageY;
    }
    /**
     * touchend event handler
     */

  }, {
    key: "touchendHandler",
    value: function touchendHandler(e) {
      e.stopPropagation();
      this.pointerDown = false;
      this.enableTransition();

      if (this.drag.endX) {
        this.updateAfterDrag();
      }

      this.clearDrag();
    }
    /**
     * touchmove event handler
     */

  }, {
    key: "touchmoveHandler",
    value: function touchmoveHandler(e) {
      e.stopPropagation();

      if (this.drag.letItGo === null) {
        this.drag.letItGo = Math.abs(this.drag.startY - e.touches[0].pageY) < Math.abs(this.drag.startX - e.touches[0].pageX);
      }

      if (this.pointerDown && this.drag.letItGo) {
        e.preventDefault();
        this.drag.endX = e.touches[0].pageX;
        this.sliderFrame.style.webkitTransition = "all 0ms ".concat(this.config.easing);
        this.sliderFrame.style.transition = "all 0ms ".concat(this.config.easing);
        var currentSlide = this.config.loop ? this.currentSlide + this.perPage : this.currentSlide;
        var currentOffset = currentSlide * (this.selectorWidth / this.perPage);
        var dragOffset = this.drag.endX - this.drag.startX;
        var offset = this.config.rtl ? currentOffset + dragOffset : currentOffset - dragOffset;
        this.sliderFrame.style[this.transformProperty] = "translate3d(".concat((this.config.rtl ? 1 : -1) * offset, "px, 0, 0)");
      }
    }
    /**
     * mousedown event handler
     */

  }, {
    key: "mousedownHandler",
    value: function mousedownHandler(e) {
      // Prevent dragging / swiping on inputs, selects and textareas
      var ignoreSiema = ['TEXTAREA', 'OPTION', 'INPUT', 'SELECT'].indexOf(e.target.nodeName) !== -1;

      if (ignoreSiema) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();
      this.pointerDown = true;
      this.drag.startX = e.pageX;
    }
    /**
     * mouseup event handler
     */

  }, {
    key: "mouseupHandler",
    value: function mouseupHandler(e) {
      e.stopPropagation();
      this.pointerDown = false;
      this.selector.style.cursor = '-webkit-grab';
      this.enableTransition();

      if (this.drag.endX) {
        this.updateAfterDrag();
      }

      this.clearDrag();
    }
    /**
     * mousemove event handler
     */

  }, {
    key: "mousemoveHandler",
    value: function mousemoveHandler(e) {
      e.preventDefault();

      if (this.pointerDown) {
        // if dragged element is a link
        // mark preventClick prop as a true
        // to detemine about browser redirection later on
        if (e.target.nodeName === 'A') {
          this.drag.preventClick = true;
        }

        this.drag.endX = e.pageX;
        this.selector.style.cursor = '-webkit-grabbing';
        this.sliderFrame.style.webkitTransition = "all 0ms ".concat(this.config.easing);
        this.sliderFrame.style.transition = "all 0ms ".concat(this.config.easing);
        var currentSlide = this.config.loop ? this.currentSlide + this.perPage : this.currentSlide;
        var currentOffset = currentSlide * (this.selectorWidth / this.perPage);
        var dragOffset = this.drag.endX - this.drag.startX;
        var offset = this.config.rtl ? currentOffset + dragOffset : currentOffset - dragOffset;
        this.sliderFrame.style[this.transformProperty] = "translate3d(".concat((this.config.rtl ? 1 : -1) * offset, "px, 0, 0)");
      }
    }
    /**
     * 
     * mouseover event handler 
     */

  }, {
    key: "mouseHoverHandler",
    value: function mouseHoverHandler(e) {
      return e;
    }
    /**
     * mouseleave event handler
     */

  }, {
    key: "mouseleaveHandler",
    value: function mouseleaveHandler(e) {
      if (this.pointerDown) {
        this.pointerDown = false;
        this.selector.style.cursor = '-webkit-grab';
        this.drag.endX = e.pageX;
        this.drag.preventClick = false;
        this.enableTransition();
        this.updateAfterDrag();
        this.clearDrag();
      }
    }
    /**
     * click event handler
     */

  }, {
    key: "clickHandler",
    value: function clickHandler(e) {
      // if the dragged element is a link
      // prevent browsers from folowing the link
      if (this.drag.preventClick) {
        e.preventDefault();
      }

      this.drag.preventClick = false;
    }
    /**
     * Autoplay slider if enabled
     */

  }, {
    key: "autoplay",
    value: function autoplay() {
      var _this3 = this;

      setInterval(function () {
        if (_this3.config.stopOnMouseHover) {
          var isHover = _this3.mouseHoverHandler();

          if (isHover === undefined) {
            _this3.next();
          }
        } else {
          _this3.next();
        }
      }, this.config.autoplayTimeout);
    }
    /**
     * Remove item from carousel.
     * @param {number} index - Item index to remove.
     * @param {function} callback - Optional callback to call after remove.
     */

  }, {
    key: "remove",
    value: function remove(index, callback) {
      if (index < 0 || index >= this.innerElements.length) {
        throw new Error('Item to remove doesn\'t exist 😭');
      } // Shift sliderFrame back by one item when:
      // 1. Item with lower index than currenSlide is removed.
      // 2. Last item is removed.


      var lowerIndex = index < this.currentSlide;
      var lastItem = this.currentSlide + this.perPage - 1 === index;

      if (lowerIndex || lastItem) {
        this.currentSlide--;
      }

      this.innerElements.splice(index, 1); // build a frame and slide to a currentSlide

      this.buildSliderFrame();

      if (callback) {
        callback.call(this);
      }
    }
    /**
     * Insert item to carousel at particular index.
     * @param {HTMLElement} item - Item to insert.
     * @param {number} index - Index of new new item insertion.
     * @param {function} callback - Optional callback to call after insert.
     */

  }, {
    key: "insert",
    value: function insert(item, index, callback) {
      if (index < 0 || index > this.innerElements.length + 1) {
        throw new Error('Unable to inset it at this index');
      }

      if (this.innerElements.indexOf(item) !== -1) {
        throw new Error('The same item in a carousel? Really? Nope.');
      } // Avoid shifting content


      var shouldItShift = index <= this.currentSlide > 0 && this.innerElements.length;
      this.currentSlide = shouldItShift ? this.currentSlide + 1 : this.currentSlide;
      this.innerElements.splice(index, 0, item); // build a frame and slide to a currentSlide

      this.buildSliderFrame();

      if (callback) {
        callback.call(this);
      }
    }
    /**
     * Prepernd item to carousel.
     * @param {HTMLElement} item - Item to prepend.
     * @param {function} callback - Optional callback to call after prepend.
     */

  }, {
    key: "prepend",
    value: function prepend(item, callback) {
      this.insert(item, 0);

      if (callback) {
        callback.call(this);
      }
    }
    /**
     * Append item to carousel.
     * @param {HTMLElement} item - Item to append.
     * @param {function} callback - Optional callback to call after append.
     */

  }, {
    key: "append",
    value: function append(item, callback) {
      this.insert(item, this.innerElements.length + 1);

      if (callback) {
        callback.call(this);
      }
    }
    /**
     * Removes listeners and optionally restores to initial markup
     * @param {boolean} restoreMarkup - Determinants about restoring an initial markup.
     * @param {function} callback - Optional callback function.
     */

  }, {
    key: "destroy",
    value: function destroy() {
      var restoreMarkup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      this.detachEvents();
      this.selector.style.cursor = 'auto';

      if (restoreMarkup) {
        var slides = document.createDocumentFragment();

        for (var i = 0; i < this.innerElements.length; i++) {
          slides.appendChild(this.innerElements[i]);
        }

        this.selector.innerHTML = '';
        this.selector.appendChild(slides);
        this.selector.removeAttribute('style');
      }

      if (callback) {
        callback.call(this);
      }
    }
  }], [{
    key: "mergeSettings",
    value: function mergeSettings(options) {
      var settings = {
        selector: '.siema',
        duration: 500,
        easing: 'ease-out',
        perPage: 1,
        startIndex: 0,
        draggable: true,
        multipleDrag: true,
        stopOnMouseHover: false,
        autoplay: false,
        autoplayTimeout: 4000,
        threshold: 20,
        loop: false,
        rtl: false,
        onInit: function onInit() {},
        onChange: function onChange() {}
      };
      var userSttings = options;

      for (var attrname in userSttings) {
        settings[attrname] = userSttings[attrname];
      }

      return settings;
    }
    /**
     * Determine if browser supports unprefixed transform property.
     * Google Chrome since version 26 supports prefix-less transform
     * @returns {string} - Transform property supported by client.
     */

  }, {
    key: "webkitOrNot",
    value: function webkitOrNot() {
      var style = document.documentElement.style;

      if (typeof style.transform === 'string') {
        return 'transform';
      }

      return 'WebkitTransform';
    }
  }]);

  return Siema;
}();

exports.default = Siema;

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isIE11 = exports.IE = void 0;

//IE detection until 10
var IE = function () {
  var ret, isTheBrowser, actualVersion, jscriptMap, jscriptVersion;
  isTheBrowser = false;
  jscriptMap = {
    "5.5": "5.5",
    "5.6": "6",
    "5.7": "7",
    "5.8": "8",
    "9": "9",
    "10": "10"
  };
  jscriptVersion = new Function("/*@cc_on return @_jscript_version; @*/")();

  if (jscriptVersion !== undefined) {
    isTheBrowser = true;
    actualVersion = jscriptMap[jscriptVersion];
  }

  ret = {
    isTheBrowser: isTheBrowser,
    actualVersion: actualVersion
  };
  return ret;
}(); //Returns true if IE 11


exports.IE = IE;
var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
exports.isIE11 = isIE11;

},{}]},{},[1]);
